import React, { FC, useEffect, useState, useRef } from 'react'
import { useHistory } from 'react-router-dom'
import { makePath } from '../../helpers/path'
import { useDispatch, useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import { format, formatCurrency } from '../../helpers/number'
import AuthService from '../../services/auth'
import { setUser } from '../../store/user/user.actions'
import { Button, Card, Modal, Tooltip } from 'antd'
import { InfoCircleOutlined, PlusOutlined } from '@ant-design/icons'
import { LoadingOutlined, RedoOutlined } from '@ant-design/icons'
import { ApplicationState } from '../../store'

const { Meta } = Card;

interface BalanceWidgetProps {
	isTurnover: boolean
	credit: number
	creditOutStanding: number
	totalTurn: number
	currentTurnover: number
	isCashback?: boolean
}

const BalanceWidget: FC<BalanceWidgetProps> = ({
	credit,
	creditOutStanding,
}) => {
	const history = useHistory()
	const userState = useSelector((state: ApplicationState) => state.user)
	const prefixState = useSelector((state: ApplicationState) => state.prefix)
	const dispatch = useDispatch()
	const [fetching, setFetching] = useState(false)
	const [isOpenMyPromotion, setIsOpenMyPromotion] = useState(false)
	const [textPromotion, setTextPromotion] = useState("")
	const [isTextOverflow, setIsTextOverflow] = useState(false)
	const myPromotionRef = useRef<HTMLDivElement>(null);

	const characterImage = prefixState?.info?.characterImage !== "" ? prefixState?.info?.characterImage : "/elements/bird.png";
	const characterImageMotion = prefixState?.info?.characterImageMotion !== "" ? prefixState?.info?.characterImageMotion : "dance";
	const myPromotion = userState?.myPromotion;

	const imagePlacehoder = "data:image/jpeg;base64,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";

	const refetchCredit = async () => {
		if (fetching) {
			return
		}
		setFetching(true)
		try {
			const res = await AuthService.getMemberInfo(true)
			dispatch(setUser(res))
		} catch ({ message }: any) {
			toast.error(message as string)
		} finally {
			setFetching(false)
		}
	}

	const handlePromotionInfo = () => {
		if (userState?.info?.bonusAvailable === false && myPromotion?.delete === false) {
			setIsOpenMyPromotion(true)
		}
	}

	useEffect(() => {
		const checkWidthAndLog = () => {
			if (myPromotionRef.current) {
				const elementWidth = myPromotionRef.current.clientWidth;
				const threshold = window.innerWidth < 768 ? 190 : 250;

				if (elementWidth >= threshold) {
					setIsTextOverflow(true)
				} else {
					setIsTextOverflow(false)
				}
			}
		};

		// เรียกฟังก์ชันตรวจสอบเมื่อ component ถูก render และทุกรอบการ render
		checkWidthAndLog();

		// เพิ่ม event listener เพื่อตรวจสอบเมื่อขนาดหน้าต่างเปลี่ยนแปลง
		window.addEventListener('resize', checkWidthAndLog);

		// คืนค่าฟังก์ชันเพื่อทำความสะอาดเมื่อ component ถูกถอดจาก DOM
		return () => {
			window.removeEventListener('resize', checkWidthAndLog);
		};
	}, []);

	useEffect(() => {
		const handleTextMyPromotion = () => {
			if (!userState?.info?.bonusAvailable) {
				return setTextPromotion(`รับโบนัส ${myPromotion?.delete === false ? myPromotion?.name : myPromotion?.key}`)
			}

			if (!userState?.info?.redeemAvailable) {
				return setTextPromotion("รับโค้ดคูปอง")
			}

			if (!userState?.info?.wheelAvailable) {
				return setTextPromotion("รับกงล้อ")
			}

			if (!userState?.info?.affiliateAvailable) {
				return setTextPromotion("รับแนะนำเพื่อน")
			}

			if (!userState?.info?.cashbackAvailable) {
				return setTextPromotion("รับแคชแบ็ก")
			}

			if (!userState?.info?.checkinAvailable) {
				return setTextPromotion("รับเช็คอิน")
			}

			return setTextPromotion("ไม่รับโบนัส")
		}

		handleTextMyPromotion()
	}, []);

	return (
		<>
			<div className="wallet-container">
				<div>
					<div>
						<span style={{ opacity: 0.75 }}>ยอดเงิน</span>
						{fetching ? (
							<LoadingOutlined style={{ fontSize: 18, marginLeft: 6 }} rev={undefined} />
						) : (
							<Tooltip
								placement="right"
								title={'อัพเดทยอดเงิน'}
								color='#121416'
							>
								<i className="fa-sharp fa-regular fa-arrows-rotate"
									style={{ fontSize: 16, marginLeft: 8 }}
									onClick={refetchCredit}></i>
							</Tooltip>
						)}
					</div>
					<div className="wallet-amount">฿ {format(credit)}</div>
				</div>

				{creditOutStanding !== 0 ? (
					<div className="credit-out-standing">
						<div className="credit-out-standing-body">
							<span style={{ fontSize: 16 }}>ยอดค้าง: {formatCurrency(creditOutStanding)}
								<Tooltip title="มีเครดิตค้างในเกม กรุณาเล่นเกมให้จบ" color={'red'} overlayInnerStyle={{ fontSize: 16 }}>
									<InfoCircleOutlined rev={undefined} style={{}} />
								</Tooltip>
							</span>
						</div>
					</div>
				) : (
					<Button className="ant-btn-secondary" style={{ width: 120 }} onClick={() => history.push(makePath('/deposit'))}>
						<PlusOutlined style={{ fontSize: 14 }} rev={undefined} />
						<span>ฝากเงิน</span>
					</Button>
				)}

				{/* <div
					onClick={handlePromotionInfo}
					className={`my-promotion ${textPromotion !== 'ไม่รับโบนัส' ? 'get-bonus' : ''}`}
				>
					<div ref={myPromotionRef} className={`my-promotion-body ${isTextOverflow ? 'overflow' : ''}`}>
						<img src="/icons/new/promotion.svg" alt="" />
						<span>{textPromotion}</span>
					</div>
				</div> */}
			</div>
			<Modal
				className="ant-popup"
				open={isOpenMyPromotion}
				title=""
				centered
				onCancel={() => setIsOpenMyPromotion(false)}
				footer={null}
			>
				<Card
					className="promotion-card bg-grey"
					cover={<img src={myPromotion?.image ? myPromotion?.image : imagePlacehoder} alt={myPromotion?.name} />}
				>
					<Meta
						title={myPromotion?.name}
						description={myPromotion?.description}
					/>
				</Card>
			</Modal>
		</>
	)
}

export default BalanceWidget
